import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
// 数据持久化
import createPersistedstate from 'vuex-persistedstate'

const logoUrl = require('@/assets/img/logo.png')
import { submitAnswer, answerSubmit } from '@/http/index'
import { getNotReadNoticeCount } from '@/http/index'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    examDetailed: {},
    userInfo: {},
    HeaderTitle: `<img src="${logoUrl}">`,
    videoPlaying: false,
    msgNum: 0
  },
  mutations: {
    SET_VIDEO_PLAYING: (state, status) => {
      state.videoPlaying = status
    },
    editExamDetailed(state, examData) {
      state.examDetailed = examData
    },
    checkHeaderText(state) {
      state.HeaderTitle = state.examDetailed.title
    },
    checkHeaderLogo(state) {
      state.HeaderTitle = `<img src="${logoUrl}">`
    },
    editUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_MSG_NUM(state, num) {
      state.msgNum = num
    }

  },
  actions: {
    submit({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        submitAnswer(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    onceSubmit({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        answerSubmit(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          if(error.code === 203 && error.data?.message === "答案重复提交"){
            router.go(-2);
          }
          reject(error)
        })
      })
    },
    loginOut({ commit, dispatch, state  }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token');
        localStorage.removeItem('secret');
        localStorage.removeItem('userinfo');
        localStorage.removeItem('hospital_id');
        localStorage.removeItem('search')
        localStorage.removeItem('testPaper')
        localStorage.removeItem('lookVideoTime')
        localStorage.removeItem('lookVideoInfo')
        commit('editUserInfo', {})
        commit('editExamDetailed', {})
        resolve();
      })
    },
    // 获取消息数量的方法
    async fetchMsgNum({ commit }) {
      try {
        // 这里替换为实际的API调用
        const response = await getNotReadNoticeCount({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        })
        commit('SET_MSG_NUM', response.data.count)
      } catch (error) {
        console.error('获取消息数量失败:', error)
      }
    },
    // 启动定时器，每分钟获取一次消息数量
    startMsgNumPolling({ dispatch }) {
      // 先立即获取一次
      dispatch('fetchMsgNum')

      // 然后设置定时器，每分钟获取一次
      const timer = setInterval(() => {
        dispatch('fetchMsgNum')
      }, 300000)

      // 返回定时器ID以便清理
      return timer
    }
  },
  plugins: [
    createPersistedstate({
      reducer(val) {
        return {
          examDetailed: val.examDetailed,
          HeaderTitle: val.HeaderTitle,
          userInfo: val.userInfo,
          editExamPaper: val.editExamPaper,
          msgNum: val.msgNum
        }
      }
    })
  ]
})
export default store
